import React, { useRef, useState } from "react";
import ProcessBar from "../MainComponent/processBar";
import "./DS.css";
import { Link } from "react-router-dom";
import DSInfo from "./DSInfo";

export default function DSDetail({ setLoader, loader }) {
  const projectId = sessionStorage.getItem("projectId");
  const mapRef = useRef(null);
  const screenRef = useRef(null);
  const [setShowMarker] = useState(false);
  const [setEmptyValues] = useState(false);

  return (
    <div className="ds-Detail">
      <div className="ds-Head">
        <div className="ds-DetailHeader">
          <Link to="/Dashboard">
            <h6 style={{ color: "#FF7C1B" }}>My Project</h6>
          </Link>
          <h6>/</h6>
          {!projectId ? <h6>Create Project</h6> : <h6>Edit Project</h6>}
        </div>
        <ProcessBar
          setLoader={setLoader}
          screenRef={screenRef}
          setEmptyValues={setEmptyValues}
          setShowMarker={setShowMarker}
          mapRef={mapRef}
        ></ProcessBar>
      </div>
      <DSInfo setLoader={setLoader} mapRef={mapRef}></DSInfo>
    </div>
  );
}
